import { Header5, InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

export interface IAddedUserInfoProps {
  title?: string;
  text: string;
  input: React.ReactNode;
}

export function AddedUserInfo({ title, text, input }: IAddedUserInfoProps) {
  return (
    <div className={styles['container']}>
      {title && (
        <div className={styles['title']}>
          <Header5>{title}</Header5>
        </div>
      )}
      <div className={styles['text']}>
        <InlineText2>{text}</InlineText2>
      </div>
      {input}
    </div>
  );
}
